/**
 * @generated SignedSource<<bcb7ac38a815ec32d570ecb93d78b462>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useUserDeets_query$data = {
  readonly currentUser: {
    readonly userDeets: {
      readonly nodes: ReadonlyArray<{
        readonly deetId: any;
        readonly other: string | null | undefined;
      } | null | undefined>;
    };
  } | null | undefined;
  readonly " $fragmentType": "useUserDeets_query";
};
export type useUserDeets_query$key = {
  readonly " $data"?: useUserDeets_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"useUserDeets_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useUserDeets_query",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "currentUser",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "orderBy",
              "value": [
                "DEET_BY_DEET_ID__SEQUENCE_ASC"
              ]
            }
          ],
          "concreteType": "UserDeetConnection",
          "kind": "LinkedField",
          "name": "userDeets",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "UserDeet",
              "kind": "LinkedField",
              "name": "nodes",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "deetId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "other",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "userDeets(orderBy:[\"DEET_BY_DEET_ID__SEQUENCE_ASC\"])"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "84d6e700ec4f405a94c64152193e68dd";

export default node;
